module.exports = __webpack_public_path__ + "static/img/5.89b9c48.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/sp/5.png
// module id = wahB
// module chunks = 0